<template>
    <!--  서브페이지  -->
    <div id="sub_area">
        <!--비주얼 영역-->
        <div class="sub_visual">
            <div class="tit_area">
                <h2 class="tit">{{ title }}</h2>
            </div>

            <div class="navigation">
                <router-link to="/" class="i_home">
                    <span>HOME</span>
                </router-link>

                <div class="item" :class="{ on: mainMenuShow }" @mouseover="mainMenuShow = true"
                    @mouseleave="mainMenuShow = false">
                    <a>{{ title }}</a>
                    <div>
                        <router-link active-class="on" tag="a" to="/notice/noticelist" @click.native="mainMenuShow = false">공지사항</router-link>
                        <router-link active-class="on" tag="a" to="/notice/newslist" @click.native="mainMenuShow = false">소식</router-link>
                    </div>
                </div>
            </div>
            <div class="sub_visual_img">
                <img :src="require('./../../assets/img/sub/sub02.png')" alt="BG" />
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    data: () => ({
        mainMenuShow: false,
        message: "Sub02MainMenu.vue",
        title: ""
    }),
    methods: {
        textTitle(path) {
            switch (path) {
              case "/notice/noticelist":{
                this.title = '공지사항';
              }break;
              case "/notice/newslist":{
                this.title = '소식';
              }break;
              case "/notice/detail":{
                this.title = '공지사항';
              }break;
              case "/notice/detail":{
                this.title = '소식';
              } break;
              case "/notice/bannerlist": {
                this.title = '배너';
              } break;
              case "/notice/bannerdetail": {
                this.title = '배너';
              } break;
              case "/notice/popupList": {
                this.title = '팝업';
              } break;
              case "/notice/popupDetail": {
                this.title = '팝업';
              } break;
            }
        }
    },
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    watch: {
        $route(to, from) {
            this.textTitle(to.path);
        }
    },

    mounted() {

    },
    created() {
        console.log("created - " + this.message);

        this.textTitle(this.$route.path);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/Sub02MainMenu.vue